import { PRODUCT_TYPES, Template } from '@schuettflix/interfaces';

type Params = {
    template: Template;
    productType: PRODUCT_TYPES;
};

export function getTemplateProductCharacteristics({ template, productType }: Params) {
    return (
        template.preSelectedProducts.find(({ type }) => type === productType)?.productCharacteristics ||
        template.allowedProducts.find(({ type }) => type === productType)?.productCharacteristics
    );
}
